import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchAvailablePhoneNumbers,
  fetchAvailablePhoneNumberCountries
} from "../../actions/callrecorder/availablePhoneNumbersActions";

export interface AvailablePhoneNumberInterface {
  uid: string;

  provider: string;
  number: number;
  country_code: string;
  phone_number_type: 'mobile' | 'local' | 'national' | 'tollfree';
  inbound_call: boolean;
  outgoing_call: boolean;
  inbound_sms: boolean;
  outgoing_sms: boolean;
  setup_fee: string;
  monthly_fee: string;
  inbound_call_price: string;
  inbound_sms_price: string;
  domestic_voice_only: boolean;
  domestic_sms_only: boolean;
}

export interface AvailablePhoneNumberCountryInterface {
  country_code: string;
  country_name: string;
  prefix: string;
  phone_number_types: string[];
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';

  countries: AvailablePhoneNumberCountryInterface[];
  countriesStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',

  countries: [],
  countriesStatus: 'idle'
};

const adaptor = createEntityAdapter<AvailablePhoneNumberInterface>({
  selectId: (entity) => entity.uid
});

const slice = createSlice({
  name: 'availablePhoneNumbers',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    resetNumbers: (state) => {
      state.entities = {};
      state.ids = [];
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index — available phone numbers
      .addCase(fetchAvailablePhoneNumbers.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchAvailablePhoneNumbers.fulfilled, (state, action) => {
        state.entities = action.payload.availablePhoneNumbers;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchAvailablePhoneNumbers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // countries
      .addCase(fetchAvailablePhoneNumberCountries.pending, (state) => {
        state.countriesStatus = 'loading';
      })
      .addCase(fetchAvailablePhoneNumberCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.countriesStatus = 'succeeded';
      })
      .addCase(fetchAvailablePhoneNumberCountries.rejected, (state) => {
        state.countriesStatus = 'failed';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  resetNumbers
} = slice.actions;

export const {
  selectById: selectAvailablePhoneNumberById,
  selectIds: selectAvailablePhoneNumberIds,
  selectEntities: selectAvailablePhoneNumberEntities,
}  = adaptor.getSelectors<RootState>(state => state.callrecorder.availablePhoneNumbers);
